import { useCallback, useEffect, useState } from "react";
import { useNavigate } from "react-router";
import { FiArrowDownCircle, FiArrowLeft, FiArrowUpCircle } from "react-icons/fi";
import { useDispatch } from "react-redux";
import { useTranslation } from "react-i18next";
import { playSong } from "../../common/actions/common.actions";
import transactionService from "../../../api/services/transactionService";
import Modal from "../../common/components/modal";
import Deposite from "./deposite";
import Withdrawal from "./withdrawal";

const Transactions = ({ setIsLoading }) => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [message, setMessage] = useState(t("processSuccessful"));
  const [accountList, setAccountList] = useState([]);
  const [activeTab, setActiveTab] = useState("deposite");
  const [balance, setBalance] = useState(0);

  const userDetails = JSON.parse(localStorage.getItem("userDetails"));

  const fetchAccountList = useCallback(async () => {
    try {
      setIsLoading(true);
      const response = await transactionService.getPaymentAccountList(
        Number(userDetails.userId)
      );
      const data = await response.json();

      if (data) {
        setAccountList(data.payload || []);
        setBalance(data.balance || 0);
      }
    } catch (error) {
      console.error("API request error:", error);
    } finally {
      setIsLoading(false);
    }
  }, [setIsLoading, userDetails.userId]);

  useEffect(() => {
    fetchAccountList();
  }, [fetchAccountList]);

  const handleSongClick = () => dispatch(playSong());

  const handleBack = () => {
    handleSongClick();
    navigate("/dashboard");
  };

  const changeTab = (tab) => {
    handleSongClick();
    setActiveTab(tab);
  };

  return (
    <div className="relative min-h-screen w-full min-w-0 flex-1 self-stretch overflow-hidden bg-gradient_start font-myanmarSansPro text-white">
      <div className="pointer-events-none absolute -left-24 top-28 h-64 w-64 rounded-full bg-emerald-300/10 blur-3xl" />
      <div className="pointer-events-none absolute -right-24 bottom-12 h-72 w-72 rounded-full bg-amber-300/10 blur-3xl" />

      <header className="sticky top-0 z-30 bg-header_green shadow-lg shadow-black/20">
        <div className="mx-auto flex min-h-[60px] w-full max-w-lg items-center px-4 py-2">
          <button
            type="button"
            onClick={handleBack}
            aria-label="Back to dashboard"
            className="flex h-10 w-10 items-center justify-center rounded-lg border border-white/10 bg-white/10 transition hover:bg-white/20 active:scale-95"
          >
            <FiArrowLeft className="h-5 w-5" />
          </button>
          <h1 className="ml-3 text-base font-semibold leading-[1.8]">{t("transaction")}</h1>
        </div>
      </header>

      <main className="relative z-10 mx-auto w-full max-w-lg px-4 pb-8 pt-3">
        <section className="mb-3 rounded-lg border border-white/10 bg-header_green/70 p-1.5 shadow-xl shadow-black/20 backdrop-blur-md">
          <div className="grid grid-cols-2 gap-1.5" role="tablist" aria-label={t("transaction")}>
            <button
              type="button"
              role="tab"
              aria-selected={activeTab === "deposite"}
              onClick={() => changeTab("deposite")}
              className={`flex min-h-[48px] items-center justify-center gap-2 rounded-lg px-3 py-1.5 text-sm font-medium leading-[1.8] transition-all duration-200 ${
                activeTab === "deposite"
                  ? "bg-white text-header_green shadow-md"
                  : "text-white/65 hover:bg-white/10 hover:text-white"
              }`}
            >
              <FiArrowDownCircle className="h-5 w-5" />
              {t("deposite")}
            </button>
            <button
              type="button"
              role="tab"
              aria-selected={activeTab === "withdraw"}
              onClick={() => changeTab("withdraw")}
              className={`flex min-h-[48px] items-center justify-center gap-2 rounded-lg px-3 py-1.5 text-sm font-medium leading-[1.8] transition-all duration-200 ${
                activeTab === "withdraw"
                  ? "bg-white text-header_green shadow-md"
                  : "text-white/65 hover:bg-white/10 hover:text-white"
              }`}
            >
              <FiArrowUpCircle className="h-5 w-5" />
              {t("withdraw")}
            </button>
          </div>
        </section>

        <div role="tabpanel">
          {activeTab === "deposite" ? (
            <Deposite
              accountList={accountList}
              t={t}
              userDetails={userDetails}
              setIsLoading={setIsLoading}
              setIsModalOpen={setIsModalOpen}
              setMessage={setMessage}
              handleSongClick={handleSongClick}
            />
          ) : (
            <Withdrawal
              accountList={accountList}
              t={t}
              userDetails={userDetails}
              balance={balance}
              fetchAccountList={fetchAccountList}
              setIsLoading={setIsLoading}
              setIsModalOpen={setIsModalOpen}
              setMessage={setMessage}
              handleSongClick={handleSongClick}
            />
          )}
        </div>
      </main>

      {isModalOpen && (
        <Modal
          title="Money Ball"
          content={message}
          onClose={() => setIsModalOpen(false)}
        />
      )}
    </div>
  );
};

export default Transactions;
